export const getYear = () => {
  const date = new Date();

  return date.getFullYear();
}